import React from "react";
import { Helmet } from "react-helmet";
import img1 from "../../../assets/thai/รับมรดกแทนที่.png";

const การรับมรดกแทนที่ = () => {
  const TITLE = "กรณีใดบ้างที่สามารถรับมรดกแทนที่กันได้";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การรับมรดกแทนที่กัน{" "}
          <mark className=" bg-[#fee9b2] rounded-xl">
            เป็นกรณีผู้ที่เป็นทายาทโดยธรรมที่มีสิทธิได้รับมรดกของเจ้ามรดกแต่ได้ตายไปก่อนเจ้ามรดก
            หรือถูกกำจัดก่อนเจ้ามรดกตาย
          </mark>{" "}
          ซึ่งในกฎหมายแพ่งและพาณิชย์ได้แยกพิจารณาเรื่องการรับมรดกแทนที่กันว่าการรับมรดกแทนที่กันนั้นมีในทายาทชนิดใดบ้าง
          ?
        </p>

        {/* 1. การรับมรดกแทนที่กันมีในทายาทชนิดใด */}
        <h2 id="initial-header">1. การรับมรดกแทนที่กันมีในทายาทชนิดใด</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <mark className=" bg-[#fee9b2] rounded-xl">
            ผู้ที่มีสิทธิรับมรดกแทนที่กันได้นั้นต้องเป็นทายาทโดยธรรมเท่านั้น
          </mark>{" "}
          แต่ก็ไม่สามารถรับมรดกแทนที่กันได้ทุกลำดับ{" "}
          <mark className=" bg-[#fee9b2] rounded-xl">
            ซึ่งลำดับที่ไม่สามารถรับมรดกแทนที่กันได้ คือ ลำดับที่ 2 บิดา มารดา
            หรือลำดับที่ 5 ปู่ ย่า ตา ยาย
          </mark>{" "}
          ส่วนทายาทโดยธรรมที่เหลือ คือ ลำดับที่ 1 3 4 หรือ 6
          ถึงแก่ความตายก่อนเจ้ามรดกตาย หรือถูกกำจัดไม่ให้รับมรดกก่อนเจ้ามรดกตาย
          ซึ่งการตายก่อนเจ้ามรดกนั้น รวมถึงการที่บุคคลนั้นตายโดยผลของกฎหมายด้วย
          คือศาลสั่งให้เป็นคนสาบสูญ ให้ผู้สืบสันดานของทายาทนั้นรับมรดกแทนที่
          หากผู้สืบสันดานตายเช่นเดียวกันก็ให้ผู้สืบสันดานของผู้สืบสันดานรับมรดกแทนที่
          สืบต่อกันเช่นนี้จนหมดสาย
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <u>
            ผู้สืบสันดานที่สามารถรับมรดกแทนที่กันได้นั้นต้องเป็นผู้สืบสันดานโดยตรงเท่านั้น
          </u>{" "}
          คือเป็นผู้สืบสายโลหิตที่แท้จริงของผู้นั้น ได้แก่ บุตรที่ชอบด้วยกฎหมาย
          และบุตรนอกกฎหมายที่บิดารองรับ เท่านั้น
          ส่วนบุตรบุญธรรมไม่สามารถรับมรดกแทนที่ได้เพราะไม่ได้เป็นผู้สืบสายโลหิตที่แท้จริง
        </p>

        {/* 2. ตัวอย่างการรับมรดกแทนที่กัน */}
        <h2 id="second-header">2. ตัวอย่างการรับมรดกแทนที่กัน</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;นายดำมีอาสามคน คือ นายหนึ่ง นายสอง
          นายสาม นายหนึ่งมีบุตรชอบด้วยกฎหมายชื่อ ด.ช.เอก
          นายหนึ่งถูกศาลสั่งให้เป็นคนสาบสูญ ต่อมา นายดำตายมีมรดก 3 ล้านบาท
          ดังนี้ มรดกของนายดำโดยปกติตกแก่อาทั้งสามคนซึ่งเป็นทายาทโดยธรรมลำดับที่
          6 คนละเท่า ๆ กัน คนละ 1 ล้านบาท
          แต่นายหนึ่งถูกศาลสั่งให้เป็นคนสาบสูญคือตายก่อนนายดำ
          นายหนึ่งมีผู้สืบสันดานคือ ด.ช.เอก
          ด.ช.เอกเข้ารับมรดกแทนที่เฉพาะส่วนของนายหนึ่ง คือ 1 ล้านบาทเท่านั้น
          สามารถอธิบายได้ตามแผนภาพล่างนี้
          <img
            src={img1}
            alt="รับมรดกแทนที่กัน"
            className="w-11/12 block ml-auto mr-auto"
          />
        </p>
      </div>

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
          <li>
            <a className="text-indigo-700 underline" href="/thai/1">
              ทายาทในกองมรดกสามารถเป็นใครได้บ้าง
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default การรับมรดกแทนที่;
